<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/product/03/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="f-a-j-j page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="f-a-j-j-content">
                            <div class="title">
                                <span>智慧养老</span>
                                <span>全平台适用</span>
                            </div>
                            <auto-row class="y-d-infos max-size">
                                <auto-col size="1 1 500px">
                                    <div class="y-d-text">基于移动互联网应用和实际业务场景，配套移动端、小程序、公众号，实现多角色线上交流与使用。养老全平台适配，业务无缝衔接。</div>
                                </auto-col>
                                <auto-col size="585px">
                                    <img src="@/assets/image/product/03/product01-1.png" class="max-size" alt="">
                                </auto-col>
                            </auto-row>
                            <auto-row class="y-d-infos max-size">
                                <auto-col size="585px">
                                    <img src="@/assets/image/product/03/product01-5.png" class="max-size"  alt="">
                                </auto-col>
                                <auto-col size="1 1 500px" style="text-align: left;margin-left:20px;">
                                    <div class="y-d-title">幸福在嘉</div>
                                    <span class="y-d-text">基于移动互联网应用和实际业务场景，配套移动端、小程序、公众号，实现多角色线上交流与使用。养老全平台适配，业务无缝衔接。</span>
                                </auto-col>
                            </auto-row>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-c-j-y-y-s-p page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="d-c-j-y-y-s-p-content">
                            <div class="title">多场景应用适配</div>
                            <div class="content">涵盖养老APP、机构PAD、服务评估APP、小程序及微信公众平台，适配各种养老业态及场景，覆盖运营机构、老人子女、护理人员、护士、评估人员、医生、照料中心人员、上门服务人员、机构人员、商家等多角色。</div>
                        </div>
                    </div>
                    <auto-row class="imgs">
                        <auto-col size="813px">
                            <img src="@/assets/image/product/03/product01-2.png" class="max-size" style="width: 70%;padding:20px 0;"  alt="">
                        </auto-col>
                    </auto-row>
                </div>
            </div>

            <div class="h-l-h-t-g-b-j page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="h-l-h-t-g-b-j-content">
                            <div class="title">
                                <span>互联互通</span>
                                <span>更便捷</span>
                            </div>
                            <auto-row class="h-l-infos max-size">
                                <auto-col size="500px">
                                    <img src="@/assets/image/product/03/product01-3.png" class="max-size"  alt="">
                                </auto-col>
                                <auto-col size="1 1 500px" style="text-align: left;margin-left:88px;">
                                    <span class="y-d-text">组建家属、机构、平台三端通过云端互通数据，通过硬件获取老人基本档案、健康信息、定位等，提高了对服务数据及事务处理的高效性和准确性，也保证了各角色间的高效沟通。</span>
                                </auto-col>
                            </auto-row>
                        </div>
                    </div>
                </div>
            </div>
<!--            <div class="page-content-child"-->
<!--                v-for="(src,i) of imgArr"-->
<!--                :key="i"-->
<!--            >-->
<!--                <div class="content-w">-->
<!--                    <img :src="src" width="100%" alt="" />-->
<!--                </div>-->
<!--            </div>-->
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    require('@/assets/image/product/03/pic-1.png'),
                    require('@/assets/image/product/03/pic-2.png'),
                    require('@/assets/image/product/03/pic-3.png'),
                ]
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }
    .page-content{
        /*padding-bottom:100px;*/
        position: relative;
        z-index:2;
    }
    /*.page-content-child:nth-child(1),.page-content-child:nth-child(2),.title span:nth-child(4){*/
    /*    background-color:#F9F9F9;*/
    /*}*/
    .page-content-child:nth-child(n){
        background-color: #FFFFFF;
    }

    .page-content-child .title span:nth-child(1){
        color:#333333;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }
    .page-content-child .title span:nth-child(2){
        color:#2FA8D0;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }

    .page-content-box{
        overflow:hidden;
    }


    .f-a-j-j .f-a-j-j-content{
        text-align: center;
        padding:200px 0 30px 0;
    }

    .y-d-infos{
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        width:100%;
        padding:158px 110px 0 110px;
        transition: all .3s;
    }

    .y-d-infos:hover{
        /* transform: translateY(-5px); */
        transform: translateY(-15px) scale(1.07);
    }

    .y-d-infos:last-child{
        padding:20px 110px 0 110px;
    }

    .y-d-text{
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        line-height: 48px;
        text-align: left;
        min-width: 200px;
    }

    .y-d-title{
        font-size: 30px;
        font-weight: 400;
        color: #2FA8D0;
        line-height: 54px;
        letter-spacing: 2px;
        padding-bottom:20px;
    }

    .d-c-j-y-y-s-p{
        position: relative;
        width:100%;
    }


    .d-c-j-y-y-s-p .d-c-j-y-y-s-p-content{
        text-align: center;
        background: #2FA8D0;
    }

    .d-c-j-y-y-s-p .d-c-j-y-y-s-p-content .title{
        font-weight: 400;
        color: #FFFFFF;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
        padding:120px 0 80px 0;
    }

    .d-c-j-y-y-s-p .d-c-j-y-y-s-p-content .content{
        font-size: 24px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 48px;
        width:60%;
        margin:0 auto;
        padding-bottom:200px;
        transition: all .3s;
    }

    .d-c-j-y-y-s-p .d-c-j-y-y-s-p-content .content:hover{
        transform: translateY(-5px);
    }

    .d-c-j-y-y-s-p .imgs{
        text-align: center;
        background: #FFFFFF;
        box-shadow: 0px 9px 30px 0px rgba(0,0,0,0.09);
        border-radius: 10px;
        width: 73%;
        margin: -150px auto 0;
        transition: all .3s;
    }

    .d-c-j-y-y-s-p .imgs:hover{
        /* transform: translateY(-5px); */
        transform: translateY(-5px) scale(1.07);
    }



    .h-l-h-t-g-b-j .h-l-h-t-g-b-j-content{
        text-align: center;
        padding:230px 0 200px 0;
    }

    .h-l-h-t-g-b-j .h-l-infos{
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        width:73%;
        margin: 40px auto 0;
        transition: all .3s;
    }

    .h-l-h-t-g-b-j .h-l-infos:hover{
        transform: translateY(-5px) scale(1.07);
    }




    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){


    }

    @media screen and (max-width: 1200px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:130px 0 180px 0;
        }



        .d-c-j-y-y-s-p .d-c-j-y-y-s-p-content .content{
            font-size: 24px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 48px;
            width:80%;
            margin:0 auto;
            padding-bottom:200px;
        }

    }

    @media screen and (max-width: 960px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:110px 0 160px 0;
        }

        .y-d-infos{
            padding:100px 10px 0 10px;
        }

        .y-d-infos:last-child{
            padding:20px 10px 0 10px;
        }

        .h-l-h-t-g-b-j .h-l-h-t-g-b-j-content{
            text-align: center;
            padding:100px 0 70px 0;
        }

        .d-c-j-y-y-s-p .d-c-j-y-y-s-p-content .content{
            width:85%;
            padding-bottom:160px;
        }

        .d-c-j-y-y-s-p .imgs{
            width: 73%;
            margin: -100px auto 0;
        }

    }

    @media screen and (max-width: 760px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:90px 0 140px 0;
        }

        .y-d-infos{
            padding:100px 10px 0 10px;
        }

        .y-d-infos:last-child{
            padding:20px 10px 0 10px;
        }

        .d-c-j-y-y-s-p .d-c-j-y-y-s-p-content .title{
            padding:80px 0 60px 0;
        }


        .h-l-h-t-g-b-j .h-l-h-t-g-b-j-content{
            text-align: center;
            padding:130px 0 100px 0;
        }

        .d-c-j-y-y-s-p .d-c-j-y-y-s-p-content .content{
            width:90%;
            padding-bottom:120px;
        }

        .d-c-j-y-y-s-p .imgs{
            width: 73%;
            margin: -80px auto 0;
        }

    }
</style>
